import React from "react";
import {
  getBGBasedOnEHR,
  getDescriptionBasedOnEHR,
  getLabelBasedOnEHR,
  getLogoBasedOnEHR,
} from "../../helper/helpers";
import {
  NEXTGEN_EHR_WHITELABEL,
  VERADIGM_EHR_WHITELABEL,
} from "../../constants/constants";
import useWindowDimensions from "../custom-hooks/useWindowDimensions";
import { TABLET_SMALL } from "../../constants/constants";

const LoginLeftSection = () => {
  const { width } = useWindowDimensions();

  return (
    <figure
      className="image-wrapper"
      style={{
        backgroundImage:
          width > TABLET_SMALL ? `url(${getBGBasedOnEHR()})` : "",
      }}
    >
      <div
        className="logo"
        style={{ backgroundImage: `url(${getLogoBasedOnEHR()})` }}
      />
      {!NEXTGEN_EHR_WHITELABEL &&
        !VERADIGM_EHR_WHITELABEL && (
          <>
            <h1 className="title-name">{getLabelBasedOnEHR()}</h1>
            <p>{getDescriptionBasedOnEHR()}</p>
          </>
        )}
      {VERADIGM_EHR_WHITELABEL && (
        <>
          <h1 className="title-name">{getLabelBasedOnEHR()}</h1>
          <p className="label-description">{getDescriptionBasedOnEHR()}</p>
        </>
      )}
    </figure>
  );
};
export default LoginLeftSection;
